import { createContext, useContext, useState, useEffect, useCallback } from "react";

const DICT = {
  en: {
    // Header / nav
    "nav.home": "Home", "nav.shop": "Shop", "nav.bundle": "Build a box",
    "nav.gift": "Gift cards", "nav.blog": "Recipes", "nav.wholesale": "Bulk",
    "nav.catering": "Corporate catering", "nav.contact": "Contact us", "nav.shop_all": "Shop all",
    "contact.eyebrow": "Say hello", "contact.title": "Contact us.",
    "contact.intro": "Questions about an order, our ingredients, or a bulk request? Drop us a line — a real person replies within one business day.",
    "contact.location": "Handcrafted in Cyprus · delivering to Cyprus & Greece",
    "contact.hours": "Mon–Fri, 09:00–17:00 (EET)",
    "contact.catering_hint": "Planning an office breakfast or event? See",
    "contact.f_name": "Your name", "contact.f_email": "Email", "contact.f_phone": "Phone (optional)", "contact.f_message": "How can we help?",
    "contact.send": "Send message", "contact.sending": "Sending…", "contact.sent": "Message sent · we'll reply within 1 business day",
    "contact.failed": "Send failed — please try again", "contact.thanks_title": "Thank you!",
    "contact.thanks_body": "Your message is in our inbox. We'll get back to you within one business day.",
    "catering.eyebrow": "Corporate catering", "catering.title": "Fuel your team, the Brunchi way.",
    "catering.intro": "Handmade real food for offices, meetings and events — from cold breakfast spreads and sharing platters to a smart fridge stocked with Brunchi in your lobby. Same or next-day set-up across Cyprus.",
    "catering.s_buffet": "Catering buffet", "catering.d_buffet": "A full grazing table of bars, granola pots, fruit and drinks for your event.",
    "catering.s_cold-breakfast": "Cold breakfast", "catering.d_cold-breakfast": "Granola & yoghurt jars, overnight oats and fruit — ready before your first meeting.",
    "catering.s_platters": "Platters", "catering.d_platters": "Bite-size protein bars, date sweets and nuts arranged for easy sharing.",
    "catering.s_smart-fridge": "Smart fridge", "catering.d_smart-fridge": "A self-service fridge we keep stocked with fresh Brunchi, right in your office.",
    "catering.how_title": "How it works",
    "catering.step_1": "Tell us your headcount, date and what you'd like to serve.",
    "catering.step_2": "We send a tailored menu and quote within one business day.",
    "catering.step_3": "We prepare everything fresh and deliver or set it up on the day.",
    "catering.contact_hint": "Prefer to just ask a question? Head to",
    "catering.form_title": "Request a quote", "catering.f_company": "Company / organisation", "catering.f_people": "Number of people",
    "catering.f_message": "Dietary needs, timings, anything else", "catering.request": "Request a quote",
    "catering.sent": "Request sent · we'll reply within 1 business day",
    "catering.thanks_body": "Your catering request is with us. Expect a menu and quote within one business day.",
    "nav.admin": "Admin", "nav.account": "Account", "nav.cart": "Cart",
    // Footer
    "footer.tagline": "Fresh · Natural · Smart. Handcrafted protein bars, gourmet granola & natural sweets. Made in Cyprus.",
    "footer.shop": "Shop", "footer.protein_bars": "Protein Bars", "footer.granola": "Granola",
    "footer.sweets": "Sweets", "footer.build_a_box": "Build a box", "footer.delivery": "Delivery",
    "footer.delivery_cy": "Cyprus · next day", "footer.delivery_gr": "Greece · 2–7 business days",
    "footer.delivery_intl": "International · 5–10 days", "footer.free_over": "Free shipping over €35 in Cyprus",
    "footer.contact": "Contact", "footer.rights": "All rights reserved",
    // Home
    "home.hero.eyebrow_fresh": "FRESH", "home.hero.eyebrow_natural": "NATURAL", "home.hero.eyebrow_smart": "SMART",
    "home.hero.title_1": "Real snacks,", "home.hero.title_2": "made",
    "home.hero.title_3": "by hand", "home.hero.title_4": "every day.",
    "home.hero.subtitle": "Small-batch protein bars, gourmet granola and natural sweets — pressed by hand from Mediterranean nuts, raw honey and roasted oats. Clean labels only.",
    "home.hero.explore": "Explore the shop", "home.hero.build_box": "Build a box",
    "home.hero.free_cy": "Free CY delivery", "home.hero.free_over": "over €35",
    "home.pledge.eyebrow": "The Brunchi pledge",
    "home.pledge.no_sugar": "No added sugar in any bar",
    "home.pledge.sweetened": "Sweetened only with blossom honey and dates",
    "home.pledge.handmade": "Everything is handmade with high-quality ingredients — premium, small-batch, always fresh.",
    "shop.box_of_12": "Box of 12 · {price}",
    "shop.box_added": "{name} · Box of 12 added",
    "nutri.kcal": "Energy",
    "nutri.protein": "Protein",
    "nutri.carbs": "Carbs",
    "nutri.sugars": "of which sugars",
    "nutri.fat": "Fat",
    "nutri.sat_fat": "Sat. fat",
    "nutri.fiber": "Fibre",
    "nutri.salt": "Salt",
    "nutri.per_serving": "Values per bar. Handmade — small natural variance possible.",
    "home.hero.feat_fresh_v": "clean labels", "home.hero.feat_natural_v": "Mediterranean", "home.hero.feat_smart_v": "high protein",
    "home.ribbon.cy": "· Next-day Cyprus",
    "home.ribbon.gr": "· 2–7 days Greece",
    "home.ribbon.clean": "· Clean ingredients", "home.ribbon.subs": "· Standing orders available",
    "home.featured.eyebrow": "Featured", "home.featured.title": "The house favourites", "home.featured.view_all": "View all",
    "home.best.eyebrow": "This week's best-sellers", "home.best.title": "What everyone else picked.",
    "home.ugc.eyebrow": "#brunchi in the wild", "home.ugc.title": "From our people.",
    "home.story.eyebrow": "Our craft", "home.story.title": "Handmade real food.",
    "home.story.body": "We roast our oats slowly, fold in Mediterranean pistachios and thyme honey, and press each bar into shape the same day it ships. The result is snack food with the soul of a bakery — and none of the shortcuts.",
    "home.story.cta": "Taste the difference",
    // Shop
    "shop.eyebrow": "Shop", "shop.title": "The full collection",
    "shop.cat.all": "All", "shop.cat.protein_bars": "Protein Bars", "shop.cat.cereal_bars": "Cereal Bars", "shop.cat.granola": "Granola",
    "shop.cat.sweets": "Sweets", "shop.cat.bundles": "Bundles",
    "shop.loading": "Loading the pantry…",
    "shop.empty_title": "The pantry is being stocked.",
    "shop.empty_body": "No products yet in this category. Check back soon or explore other collections.",
    "shop.add_to_cart": "Add to cart",
    "shop.sign_in_fav": "Sign in to save favourites",
    // Cart
    "cart.title": "Your basket", "cart.empty_title": "Your basket is quiet.",
    "cart.empty_body": "Discover our latest artisan bars.", "cart.browse": "Browse the shop",
    "cart.free_unlocked": "Free delivery unlocked in Cyprus", "cart.free_progress": "until free CY delivery",
    "cart.subtotal": "Subtotal", "cart.min_order_prefix": "Minimum order is",
    "cart.min_order_add": "add", "cart.min_order_more": "more.", "cart.checkout": "Continue to checkout",
    // Checkout
    "checkout.title": "Checkout", "checkout.empty": "Your basket is empty.",
    "checkout.continue_shopping": "Continue shopping",
    "checkout.contact": "Contact", "checkout.email": "Email", "checkout.name": "Full name", "checkout.phone": "Phone",
    "checkout.sex_optional": "Sex (optional)", "checkout.sex_female": "Female",
    "checkout.sex_male": "Male", "checkout.sex_other": "Other",
    "checkout.dob": "Date of birth (YYYY-MM-DD, optional)",
    "checkout.address": "Delivery address",
    "checkout.city": "City", "checkout.street": "Street address",
    "checkout.apartment": "Apartment, suite (optional)", "checkout.postal": "Postal code",
    "checkout.notes": "Delivery notes (optional)",
    "checkout.redirecting": "Redirecting to Stripe…",
    "checkout.pay_with_stripe": "Pay {total} with Stripe",
    "checkout.start_standing": "Start standing order · {total} {freq}",
    "checkout.freq.week_1": "weekly", "checkout.freq.week_2": "every 2 weeks",
    "checkout.freq.month_1": "monthly", "checkout.freq.month_2": "every 2 months",
    "checkout.min_order": "Minimum order is {amount}.",
    "checkout.summary": "Order summary",
    "checkout.standing_toggle": "Make it a standing order",
    "checkout.standing_help": "Auto-repeat this basket. Cancel anytime.",
    "checkout.subtotal": "Subtotal", "checkout.shipping": "Shipping",
    "checkout.free": "FREE", "checkout.discount": "Discount", "checkout.total": "Total",
    "checkout.promo_placeholder": "Promo code", "checkout.apply": "Apply", "checkout.remove": "remove",
    "checkout.gift_placeholder": "Gift card code",
    "checkout.use_store_credit": "Use my store credit",
    "checkout.estimated": "Estimated: {days}",
    "checkout.failed": "Checkout failed",
    "checkout.subs_sign_in_required": "Standing orders need an account so we can manage your renewals. Please sign in first.",
    // ProductDetail
    "pdp.loading": "Loading…", "pdp.not_found": "Product not found.",
    "pdp.back": "Back to shop", "pdp.handcrafted": "Handcrafted in Cyprus",
    "pdp.out_of_stock": "Out of stock", "pdp.add_to_basket": "Add to basket",
    "pdp.ingredients": "Ingredients", "pdp.nutrition": "Nutrition (per serving)",
    "pdp.reviews.eyebrow": "Customer reviews",
    "pdp.reviews.avg_from": "from {count} approved review{s}",
    "pdp.reviews.be_first": "Be the first to share your thoughts",
    "pdp.reviews.leave": "Leave a review",
    "pdp.reviews.headline": "Headline (optional)",
    "pdp.reviews.how_was": "How was it?",
    "pdp.reviews.submitting": "Submitting…", "pdp.reviews.submit": "Submit review",
    "pdp.reviews.submitted": "Review submitted · pending admin approval",
    "pdp.reviews.approval_note": "Reviews are published only after admin approval — helps keep the tone honest.",
    "pdp.reviews.sign_in": "Please sign in to leave a review",
    "pdp.reviews.submit_failed": "Submit failed",
    // Account
    "account.eyebrow": "Account", "account.loading": "Loading…",
    "account.signout": "Sign out",
    "account.referral.eyebrow": "Refer a friend", "account.referral.title": "Give 10% · Get 10% credit",
    "account.referral.copy": "Copy", "account.referral.copied": "Referral link copied",
    "account.credit.eyebrow": "Store credit",
    "account.loyalty.eyebrow": "Loyalty stamps",
    "account.loyalty.club_badge": "Brunchi Club",
    "account.loyalty.club_active_until": "Free CY delivery until {date}",
    "account.loyalty.to_reward": "{n} more order{s} to a €5 reward · {c} to Brunchi Club",
    "account.loyalty.unlocked": "Reward unlocked — check your email!",
    // Loyalty Rewards section
    "loyalty.rewards.title": "My rewards",
    "loyalty.rewards.help": "Apply the code at checkout to redeem. One code per basket.",
    "loyalty.rewards.empty": "No rewards yet — every 5 orders earns you a €5 code, automatically.",
    "loyalty.rewards.available": "Available",
    "loyalty.rewards.used": "Used",
    "loyalty.rewards.copy": "Copy code",
    "loyalty.rewards.copied": "Code copied — paste it at checkout",
    "loyalty.rewards.value_fixed": "€{value} off",
    "loyalty.rewards.value_percent": "{value}% off",
    // Standing orders
    "account.subs.title": "Standing orders",
    "account.subs.help": "Pause up to 2 cycles or cancel anytime",
    "account.subs.empty": "No standing orders yet. Set one up from checkout to never run out.",
    "account.subs.per_cycle": "{n} items · {total} per cycle",
    "account.subs.paused_until": "Paused until {date}",
    "account.subs.pause_1": "Pause 1 cycle", "account.subs.pause_2": "Pause 2 cycles",
    "account.subs.add_next": "Add to next cycle", "account.subs.cancel": "Cancel",
    "account.subs.resume": "Resume now",
    "account.subs.next_extras": "Next cycle includes {n} extra item{s}",
    "account.subs.cancel_confirm": "Cancel this standing order?",
    "account.subs.cancelled": "Standing order cancelled",
    "account.subs.paused": "Paused for {n} cycle{s}",
    "account.subs.resumed": "Resumed",
    "account.subs.addon.eyebrow": "Next cycle add-ons",
    "account.subs.addon.help": "Extras charged on the next scheduled cycle only. Add nothing to reset.",
    "account.subs.addon.save": "Save add-ons for next cycle",
    "account.subs.addon.saved": "Add-ons saved · included in next cycle",
    "account.orders.title": "Your orders",
    "account.orders.empty_prefix": "No orders yet.",
    "account.orders.start": "Start with a taste →",
    "account.orders.reorder": "Reorder",
    "account.orders.reordered": "Reordered {num} · basket updated",
    "account.orders.pair_prompt": "Add {name}?",
    "account.orders.pair_desc": "Pairs well with your reorder",
    "account.orders.pair_add": "Add",
    "account.quotes.title": "Your wholesale enquiries",
    "account.quotes.another": "Request another",
    "account.status.pending_kitchen": "In the kitchen", "account.status.preparing": "Preparing",
    "account.status.ready": "Ready for courier", "account.status.dispatched": "Dispatched",
    "account.status.delivered": "Delivered", "account.status.cancelled": "Cancelled",
    // Newsletter
    "newsletter.eyebrow": "First taste on us",
    "newsletter.title": "10% off your first order.",
    "newsletter.subtitle": "Join the Brunchi list. Unlock a one-time code, plus new drops & pantry notes — no spam.",
    "newsletter.name_ph": "Your name (optional)",
    "newsletter.email_ph": "Your email",
    "newsletter.submit": "Send me my 10% code",
    "newsletter.sending": "Sending code…",
    "newsletter.terms": "One-time use · Min order €25 · Unsubscribe any time.",
    "newsletter.welcome": "Welcome! Your code is ready.",
    "newsletter.youre_in": "You're in.",
    "newsletter.code_use": "Use this code at checkout for 10% off orders over €25.",
    "newsletter.your_code": "Your code",
    "newsletter.start_shopping": "Start shopping",
    "newsletter.failed": "Signup failed",
    "loyalty.rewards.copy_failed": "Copy failed — long-press to copy",
    "account.cadence.every_week": "every week",
    "account.cadence.every_2_weeks": "every 2 weeks",
    "account.cadence.every_month": "every month",
    "account.cadence.every_2_months": "every 2 months",
    "account.sub_status.active": "active",
    "account.sub_status.paused": "paused",
    "account.sub_status.cancelled": "cancelled",
    // Auth
    "auth.welcome_back": "Welcome back",
    "auth.create_account": "Create an account",
    "auth.sub": "Save addresses, reorder favourites, track shipments.",
    "auth.google": "Continue with Google",
    "auth.or": "or",
    "auth.name": "Full name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.sex_optional": "Sex (optional)",
    "auth.sex_female": "Female",
    "auth.sex_male": "Male",
    "auth.sex_other": "Other",
    "auth.dob_optional": "DOB (optional)",
    "auth.busy": "…",
    "auth.sign_in": "Sign in",
    "auth.create_btn": "Create account",
    "auth.new_here": "New here? Create an account",
    "auth.already": "Already have an account? Sign in",
    "auth.welcome_toast": "Welcome{name}!",
    "auth.failed": "Authentication failed",
    // Blog
    "blog.eyebrow": "Recipes & notes",
    "blog.title": "The Brunchi kitchen.",
    "blog.subtitle": "Simple recipes, pantry stories and quick reads — no fluff, just food we actually make.",
    "blog.coming": "Recipes are coming soon.",
    "blog.read": "Read",
    "blog.loading": "Loading…",
    "blog.not_found": "Recipe not found.",
    "blog.back_all": "Back to all recipes →",
    "blog.default_tag": "Recipe",
    // Countries
    "country.CY": "Cyprus",
    "country.GR": "Greece",
    "country.INTL": "International",
    // Order tracking
    "account.orders.tracking": "ACS tracking",
    "account.orders.track_link": "Track shipment",
    "account.orders.eta": "Est. delivery",
    "account.orders.eta_range": "{from_date} – {to_date}",
    "account.orders.eta_single": "by {date}",
    "account.orders.delivered": "Delivered",
    "account.orders.in_transit": "In transit",
    "newsletter.dismiss": "Dismiss",
  },
  el: {
    "nav.home": "Αρχική", "nav.shop": "Κατάστημα", "nav.bundle": "Φτιάξε το κουτί",
    "nav.gift": "Δωροκάρτες", "nav.blog": "Συνταγές", "nav.wholesale": "Χονδρική",
    "nav.catering": "Εταιρικό catering", "nav.contact": "Επικοινωνία", "nav.shop_all": "Όλα τα προϊόντα",
    "contact.eyebrow": "Πείτε μας ένα γεια", "contact.title": "Επικοινωνήστε μαζί μας.",
    "contact.intro": "Ερωτήσεις για παραγγελία, συστατικά ή μεγάλη ποσότητα; Γράψτε μας — απαντάμε εντός μίας εργάσιμης ημέρας.",
    "contact.location": "Χειροποίητα στην Κύπρο · παραδόσεις σε Κύπρο & Ελλάδα",
    "contact.hours": "Δευ–Παρ, 09:00–17:00",
    "contact.catering_hint": "Οργανώνετε πρωινό γραφείου ή εκδήλωση? Δείτε",
    "contact.f_name": "Το όνομά σας", "contact.f_email": "Email", "contact.f_phone": "Τηλέφωνο (προαιρετικό)", "contact.f_message": "Πώς μπορούμε να βοηθήσουμε;",
    "contact.send": "Αποστολή", "contact.sending": "Αποστολή…", "contact.sent": "Το μήνυμα στάλθηκε · απαντάμε εντός 1 εργάσιμης",
    "contact.failed": "Η αποστολή απέτυχε — δοκιμάστε ξανά", "contact.thanks_title": "Ευχαριστούμε!",
    "contact.thanks_body": "Το μήνυμά σας έφτασε. Θα επικοινωνήσουμε εντός μίας εργάσιμης ημέρας.",
    "catering.eyebrow": "Εταιρικό catering", "catering.title": "Ενέργεια για την ομάδα σας, με τον τρόπο της Brunchi.",
    "catering.intro": "Χειροποίητο, αληθινό φαγητό για γραφεία, συναντήσεις και εκδηλώσεις — από κρύο πρωινό και πλατό μέχρι smart ψυγείο γεμάτο Brunchi στον χώρο σας. Στήσιμο ίδια ή επόμενη μέρα σε όλη την Κύπρο.",
    "catering.s_buffet": "Μπουφέ catering", "catering.d_buffet": "Πλούσιο τραπέζι με μπάρες, γκρανόλα, φρούτα και ροφήματα για την εκδήλωσή σας.",
    "catering.s_cold-breakfast": "Κρύο πρωινό", "catering.d_cold-breakfast": "Βαζάκια γκρανόλα με γιαούρτι, overnight oats και φρούτα — έτοιμα πριν την πρώτη συνάντηση.",
    "catering.s_platters": "Πλατό", "catering.d_platters": "Μπουκίτσες από πρωτεϊνικές μπάρες, γλυκά με χουρμά και ξηρούς καρπούς.",
    "catering.s_smart-fridge": "Smart ψυγείο", "catering.d_smart-fridge": "Ψυγείο self-service που γεμίζουμε με φρέσκα Brunchi, μέσα στο γραφείο σας.",
    "catering.how_title": "Πώς λειτουργεί",
    "catering.step_1": "Πείτε μας αριθμό ατόμων, ημερομηνία και τι θέλετε να σερβίρετε.",
    "catering.step_2": "Σας στέλνουμε μενού και προσφορά εντός μίας εργάσιμης ημέρας.",
    "catering.step_3": "Ετοιμάζουμε όλα φρέσκα και παραδίδουμε ή στήνουμε την ημέρα της εκδήλωσης.",
    "catering.contact_hint": "Θέλετε απλώς να ρωτήσετε κάτι? Πηγαίνετε στην",
    "catering.form_title": "Ζητήστε προσφορά", "catering.f_company": "Εταιρεία / οργανισμός", "catering.f_people": "Αριθμός ατόμων",
    "catering.f_message": "Διατροφικές ανάγκες, ώρες, οτιδήποτε άλλο", "catering.request": "Ζητήστε προσφορά",
    "catering.sent": "Το αίτημα στάλθηκε · απαντάμε εντός 1 εργάσιμης",
    "catering.thanks_body": "Λάβαμε το αίτημά σας. Περιμένετε μενού και προσφορά εντός μίας εργάσιμης ημέρας.",
    "nav.admin": "Διαχείριση", "nav.account": "Λογαριασμός", "nav.cart": "Καλάθι",
    "footer.tagline": "Φρέσκο · Φυσικό · Έξυπνο. Χειροποίητες μπάρες πρωτεΐνης, γκουρμέ granola & φυσικά γλυκά. Φτιαγμένα στην Κύπρο.",
    "footer.shop": "Κατάστημα", "footer.protein_bars": "Μπάρες Πρωτεΐνης", "footer.granola": "Granola",
    "footer.sweets": "Γλυκά", "footer.build_a_box": "Φτιάξε το κουτί", "footer.delivery": "Παράδοση",
    "footer.delivery_cy": "Κύπρος · επόμενη μέρα", "footer.delivery_gr": "Ελλάδα · 2–7 εργάσιμες",
    "footer.delivery_intl": "Διεθνώς · 5–10 ημέρες", "footer.free_over": "Δωρεάν αποστολή άνω των €35 στην Κύπρο",
    "footer.contact": "Επικοινωνία", "footer.rights": "Με επιφύλαξη κάθε δικαιώματος",
    "home.hero.eyebrow_fresh": "ΦΡΕΣΚΟ", "home.hero.eyebrow_natural": "ΦΥΣΙΚΟ", "home.hero.eyebrow_smart": "ΕΞΥΠΝΟ",
    "home.hero.title_1": "Πραγματικά σνακ,", "home.hero.title_2": "φτιαγμένα",
    "home.hero.title_3": "στο χέρι", "home.hero.title_4": "κάθε μέρα.",
    "home.hero.subtitle": "Χειροποίητες μπάρες πρωτεΐνης, γκουρμέ granola και φυσικά γλυκά — πιεσμένες με το χέρι από μεσογειακούς ξηρούς καρπούς, ωμό μέλι και ψητή βρώμη. Μόνο καθαρά συστατικά.",
    "home.hero.explore": "Δες το κατάστημα", "home.hero.build_box": "Φτιάξε το κουτί",
    "home.hero.free_cy": "Δωρεάν αποστολή Κύπρος", "home.hero.free_over": "άνω των €35",
    "home.pledge.eyebrow": "Η δέσμευση Brunchi",
    "home.pledge.no_sugar": "Καμία προσθήκη ζάχαρης σε καμία μπάρα",
    "home.pledge.sweetened": "Γλυκαίνουμε μόνο με άνθος μελιού και χουρμάδες",
    "home.pledge.handmade": "Όλα είναι χειροποίητα με υψηλής ποιότητας υλικά — premium, μικρές παρτίδες, πάντα φρέσκα.",
    "shop.box_of_12": "Κουτί των 12 · {price}",
    "shop.box_added": "{name} · Το κουτί των 12 προστέθηκε",
    "nutri.kcal": "Ενέργεια",
    "nutri.protein": "Πρωτεΐνη",
    "nutri.carbs": "Υδατάνθρακες",
    "nutri.sugars": "εκ των οποίων σάκχαρα",
    "nutri.fat": "Λιπαρά",
    "nutri.sat_fat": "Κορεσμένα",
    "nutri.fiber": "Φυτικές ίνες",
    "nutri.salt": "Αλάτι",
    "nutri.per_serving": "Τιμές ανά μπάρα. Χειροποίητες — μικρή φυσική διακύμανση.",
    "home.hero.feat_fresh_v": "καθαρά συστατικά", "home.hero.feat_natural_v": "μεσογειακά", "home.hero.feat_smart_v": "υψηλή πρωτεΐνη",
    "home.ribbon.cy": "· Επόμενη μέρα Κύπρος",
    "home.ribbon.gr": "· 2–7 μέρες Ελλάδα",
    "home.ribbon.clean": "· Καθαρά συστατικά", "home.ribbon.subs": "· Διαθέσιμες σταθερές παραγγελίες",
    "home.featured.eyebrow": "Επιλογές", "home.featured.title": "Οι αγαπημένες του σπιτιού", "home.featured.view_all": "Δες όλα",
    "home.best.eyebrow": "Τα best-sellers της εβδομάδας", "home.best.title": "Αυτά που διάλεξαν όλοι.",
    "home.ugc.eyebrow": "#brunchi στη φύση", "home.ugc.title": "Από τους ανθρώπους μας.",
    "home.story.eyebrow": "Η τέχνη μας", "home.story.title": "Χειροποίητο, πραγματικό φαγητό.",
    "home.story.body": "Ψήνουμε αργά τη βρώμη, προσθέτουμε μεσογειακά φιστίκια Αιγίνης και μέλι θυμαρίσιο, και πιέζουμε κάθε μπάρα την ίδια μέρα που φεύγει. Το αποτέλεσμα είναι σνακ με ψυχή αρτοποιείου — χωρίς συμβιβασμούς.",
    "home.story.cta": "Δοκίμασε τη διαφορά",
    "shop.eyebrow": "Κατάστημα", "shop.title": "Όλη η συλλογή",
    "shop.cat.all": "Όλα", "shop.cat.protein_bars": "Μπάρες Πρωτεΐνης", "shop.cat.cereal_bars": "Μπάρες Δημητριακών", "shop.cat.granola": "Granola",
    "shop.cat.sweets": "Γλυκά", "shop.cat.bundles": "Κουτιά",
    "shop.loading": "Φορτώνει το ντουλάπι…",
    "shop.empty_title": "Το ντουλάπι γεμίζει.",
    "shop.empty_body": "Δεν υπάρχουν ακόμα προϊόντα σε αυτή την κατηγορία. Δες σύντομα ξανά ή περιήγησε άλλες συλλογές.",
    "shop.add_to_cart": "Προσθήκη στο καλάθι",
    "shop.sign_in_fav": "Σύνδεση για αποθήκευση αγαπημένων",
    "cart.title": "Το καλάθι σου", "cart.empty_title": "Το καλάθι σου είναι ήσυχο.",
    "cart.empty_body": "Ανακάλυψε τις τελευταίες χειροποίητες μπάρες μας.", "cart.browse": "Περιήγηση καταστήματος",
    "cart.free_unlocked": "Δωρεάν αποστολή ξεκλείδωσε στην Κύπρο", "cart.free_progress": "μέχρι δωρεάν αποστολή Κύπρος",
    "cart.subtotal": "Υποσύνολο", "cart.min_order_prefix": "Ελάχιστη παραγγελία είναι",
    "cart.min_order_add": "πρόσθεσε", "cart.min_order_more": "ακόμη.", "cart.checkout": "Συνέχεια στο ταμείο",
    "checkout.title": "Ταμείο", "checkout.empty": "Το καλάθι σου είναι άδειο.",
    "checkout.continue_shopping": "Συνέχεια αγορών",
    "checkout.contact": "Στοιχεία επικοινωνίας", "checkout.email": "Email", "checkout.name": "Ονοματεπώνυμο", "checkout.phone": "Τηλέφωνο",
    "checkout.sex_optional": "Φύλο (προαιρετικό)", "checkout.sex_female": "Γυναίκα",
    "checkout.sex_male": "Άνδρας", "checkout.sex_other": "Άλλο",
    "checkout.dob": "Ημ/νία γέννησης (ΕΕΕΕ-ΜΜ-ΗΗ, προαιρετικό)",
    "checkout.address": "Διεύθυνση παράδοσης",
    "checkout.city": "Πόλη", "checkout.street": "Διεύθυνση",
    "checkout.apartment": "Διαμέρισμα, όροφος (προαιρετικό)", "checkout.postal": "Τ.Κ.",
    "checkout.notes": "Σημειώσεις παράδοσης (προαιρετικό)",
    "checkout.redirecting": "Ανακατεύθυνση στο Stripe…",
    "checkout.pay_with_stripe": "Πλήρωσε {total} με Stripe",
    "checkout.start_standing": "Ξεκίνα σταθερή παραγγελία · {total} {freq}",
    "checkout.freq.week_1": "εβδομαδιαία", "checkout.freq.week_2": "κάθε 2 εβδομάδες",
    "checkout.freq.month_1": "μηνιαία", "checkout.freq.month_2": "κάθε 2 μήνες",
    "checkout.min_order": "Ελάχιστη παραγγελία είναι {amount}.",
    "checkout.summary": "Σύνοψη παραγγελίας",
    "checkout.standing_toggle": "Κάνε τη σταθερή παραγγελία",
    "checkout.standing_help": "Αυτόματη επανάληψη αυτού του καλαθιού. Ακύρωση οποτεδήποτε.",
    "checkout.subtotal": "Υποσύνολο", "checkout.shipping": "Αποστολή",
    "checkout.free": "ΔΩΡΕΑΝ", "checkout.discount": "Έκπτωση", "checkout.total": "Σύνολο",
    "checkout.promo_placeholder": "Κωδικός έκπτωσης", "checkout.apply": "Εφαρμογή", "checkout.remove": "αφαίρεση",
    "checkout.gift_placeholder": "Κωδικός δωροκάρτας",
    "checkout.use_store_credit": "Χρήση πίστωσης καταστήματος",
    "checkout.estimated": "Εκτίμηση: {days}",
    "checkout.failed": "Η παραγγελία απέτυχε",
    "checkout.subs_sign_in_required": "Οι σταθερές παραγγελίες χρειάζονται λογαριασμό για να διαχειριστούμε τις ανανεώσεις σου. Συνδέσου πρώτα.",
    "pdp.loading": "Φορτώνει…", "pdp.not_found": "Το προϊόν δεν βρέθηκε.",
    "pdp.back": "Πίσω στο κατάστημα", "pdp.handcrafted": "Χειροποίητο στην Κύπρο",
    "pdp.out_of_stock": "Εξαντλήθηκε", "pdp.add_to_basket": "Προσθήκη στο καλάθι",
    "pdp.ingredients": "Συστατικά", "pdp.nutrition": "Διατροφικά (ανά μερίδα)",
    "pdp.reviews.eyebrow": "Κριτικές πελατών",
    "pdp.reviews.avg_from": "από {count} εγκεκριμένες κριτικές",
    "pdp.reviews.be_first": "Γίνε ο πρώτος που θα μοιραστεί τη γνώμη του",
    "pdp.reviews.leave": "Άφησε μια κριτική",
    "pdp.reviews.headline": "Τίτλος (προαιρετικός)",
    "pdp.reviews.how_was": "Πώς σου φάνηκε;",
    "pdp.reviews.submitting": "Υποβολή…", "pdp.reviews.submit": "Υποβολή κριτικής",
    "pdp.reviews.submitted": "Η κριτική υποβλήθηκε · εκκρεμεί έγκριση",
    "pdp.reviews.approval_note": "Οι κριτικές δημοσιεύονται μετά από έγκριση — για να διατηρήσουμε την ειλικρίνεια.",
    "pdp.reviews.sign_in": "Παρακαλώ συνδέσου για να αφήσεις κριτική",
    "pdp.reviews.submit_failed": "Η υποβολή απέτυχε",
    "account.eyebrow": "Λογαριασμός", "account.loading": "Φορτώνει…",
    "account.signout": "Αποσύνδεση",
    "account.referral.eyebrow": "Πρόσκληση φίλου", "account.referral.title": "Δώσε 10% · Πάρε 10% πίστωση",
    "account.referral.copy": "Αντιγραφή", "account.referral.copied": "Ο σύνδεσμος αντιγράφηκε",
    "account.credit.eyebrow": "Πίστωση καταστήματος",
    "account.loyalty.eyebrow": "Σφραγίδες πίστης",
    "account.loyalty.club_badge": "Brunchi Club",
    "account.loyalty.club_active_until": "Δωρεάν αποστολή Κύπρου μέχρι {date}",
    "account.loyalty.to_reward": "{n} ακόμη παραγγελίες για μια ανταμοιβή €5 · {c} για το Brunchi Club",
    "account.loyalty.unlocked": "Η ανταμοιβή ξεκλείδωσε — δες το email σου!",
    "loyalty.rewards.title": "Οι ανταμοιβές μου",
    "loyalty.rewards.help": "Εφάρμοσε τον κωδικό στο ταμείο. Ένας κωδικός ανά καλάθι.",
    "loyalty.rewards.empty": "Καμία ανταμοιβή ακόμη — κάθε 5 παραγγελίες κερδίζεις αυτόματα κωδικό €5.",
    "loyalty.rewards.available": "Διαθέσιμος",
    "loyalty.rewards.used": "Χρησιμοποιήθηκε",
    "loyalty.rewards.copy": "Αντιγραφή κωδικού",
    "loyalty.rewards.copied": "Ο κωδικός αντιγράφηκε — επικόλλησέ τον στο ταμείο",
    "loyalty.rewards.value_fixed": "€{value} έκπτωση",
    "loyalty.rewards.value_percent": "{value}% έκπτωση",
    "account.subs.title": "Σταθερές παραγγελίες",
    "account.subs.help": "Παύση έως 2 κύκλους ή ακύρωση οποτεδήποτε",
    "account.subs.empty": "Δεν υπάρχουν σταθερές παραγγελίες. Ρύθμισε μία από το ταμείο για να μη σου τελειώνουν ποτέ.",
    "account.subs.per_cycle": "{n} προϊόντα · {total} ανά κύκλο",
    "account.subs.paused_until": "Σε παύση μέχρι {date}",
    "account.subs.pause_1": "Παύση 1 κύκλου", "account.subs.pause_2": "Παύση 2 κύκλων",
    "account.subs.add_next": "Προσθήκη στον επόμενο κύκλο", "account.subs.cancel": "Ακύρωση",
    "account.subs.resume": "Συνέχιση τώρα",
    "account.subs.next_extras": "Ο επόμενος κύκλος περιλαμβάνει {n} επιπλέον προϊόντα",
    "account.subs.cancel_confirm": "Ακύρωση αυτής της σταθερής παραγγελίας;",
    "account.subs.cancelled": "Η σταθερή παραγγελία ακυρώθηκε",
    "account.subs.paused": "Παύση για {n} κύκλο{s}",
    "account.subs.resumed": "Συνεχίστηκε",
    "account.subs.addon.eyebrow": "Πρόσθετα επόμενου κύκλου",
    "account.subs.addon.help": "Τα πρόσθετα χρεώνονται μόνο στον επόμενο προγραμματισμένο κύκλο. Μηδένισε για επαναφορά.",
    "account.subs.addon.save": "Αποθήκευση πρόσθετων για τον επόμενο κύκλο",
    "account.subs.addon.saved": "Τα πρόσθετα αποθηκεύτηκαν · θα συμπεριληφθούν στον επόμενο κύκλο",
    "account.orders.title": "Οι παραγγελίες σου",
    "account.orders.empty_prefix": "Καμία παραγγελία ακόμη.",
    "account.orders.start": "Ξεκίνα με μια γεύση →",
    "account.orders.reorder": "Επανάληψη",
    "account.orders.reordered": "Επαναλήφθηκε {num} · το καλάθι ενημερώθηκε",
    "account.orders.pair_prompt": "Πρόσθεσε {name};",
    "account.orders.pair_desc": "Ταιριάζει με την παραγγελία σου",
    "account.orders.pair_add": "Προσθήκη",
    "account.quotes.title": "Τα αιτήματα χονδρικής σου",
    "account.quotes.another": "Νέο αίτημα",
    "account.status.pending_kitchen": "Στην κουζίνα", "account.status.preparing": "Ετοιμάζεται",
    "account.status.ready": "Έτοιμη για κούριερ", "account.status.dispatched": "Απεστάλη",
    "account.status.delivered": "Παραδόθηκε", "account.status.cancelled": "Ακυρώθηκε",
    "newsletter.eyebrow": "Πρώτη γεύση δώρο",
    "newsletter.title": "10% έκπτωση στην πρώτη σου παραγγελία.",
    "newsletter.subtitle": "Μπες στη λίστα Brunchi. Ξεκλείδωσε μοναδικό κωδικό, νέα προϊόντα & σημειώσεις — χωρίς spam.",
    "newsletter.name_ph": "Το όνομά σου (προαιρετικό)",
    "newsletter.email_ph": "Το email σου",
    "newsletter.submit": "Στείλε μου τον κωδικό 10%",
    "newsletter.sending": "Αποστολή κωδικού…",
    "newsletter.terms": "Μία χρήση · Ελάχ. παραγγελία €25 · Απεγγραφή οποτεδήποτε.",
    "newsletter.welcome": "Καλωσόρισες! Ο κωδικός σου είναι έτοιμος.",
    "newsletter.youre_in": "Είσαι μέσα.",
    "newsletter.code_use": "Χρησιμοποίησε τον κωδικό στο ταμείο για 10% έκπτωση σε παραγγελίες άνω των €25.",
    "newsletter.your_code": "Ο κωδικός σου",
    "newsletter.start_shopping": "Ξεκίνα αγορές",
    "newsletter.failed": "Η εγγραφή απέτυχε",
    "loyalty.rewards.copy_failed": "Η αντιγραφή απέτυχε — παρατεταμένο πάτημα για αντιγραφή",
    "account.cadence.every_week": "κάθε εβδομάδα",
    "account.cadence.every_2_weeks": "κάθε 2 εβδομάδες",
    "account.cadence.every_month": "κάθε μήνα",
    "account.cadence.every_2_months": "κάθε 2 μήνες",
    "account.sub_status.active": "ενεργή",
    "account.sub_status.paused": "σε παύση",
    "account.sub_status.cancelled": "ακυρωμένη",
    "auth.welcome_back": "Καλώς επέστρεψες",
    "auth.create_account": "Δημιουργία λογαριασμού",
    "auth.sub": "Αποθήκευσε διευθύνσεις, επαναπαραγγελία αγαπημένων, παρακολούθηση αποστολών.",
    "auth.google": "Συνέχεια με Google",
    "auth.or": "ή",
    "auth.name": "Ονοματεπώνυμο",
    "auth.email": "Email",
    "auth.password": "Κωδικός",
    "auth.sex_optional": "Φύλο (προαιρετικό)",
    "auth.sex_female": "Γυναίκα",
    "auth.sex_male": "Άνδρας",
    "auth.sex_other": "Άλλο",
    "auth.dob_optional": "Ημ/νία γέννησης (προαιρετικό)",
    "auth.busy": "…",
    "auth.sign_in": "Σύνδεση",
    "auth.create_btn": "Δημιουργία λογαριασμού",
    "auth.new_here": "Καινούριος εδώ; Δημιούργησε λογαριασμό",
    "auth.already": "Έχεις ήδη λογαριασμό; Συνδέσου",
    "auth.welcome_toast": "Καλωσόρισες{name}!",
    "auth.failed": "Η ταυτοποίηση απέτυχε",
    "blog.eyebrow": "Συνταγές & σημειώσεις",
    "blog.title": "Η κουζίνα Brunchi.",
    "blog.subtitle": "Απλές συνταγές, ιστορίες κουζίνας και σύντομες αναγνώσεις — χωρίς περιττά, μόνο φαγητό που πραγματικά φτιάχνουμε.",
    "blog.coming": "Οι συνταγές έρχονται σύντομα.",
    "blog.read": "Διάβασε",
    "blog.loading": "Φορτώνει…",
    "blog.not_found": "Η συνταγή δεν βρέθηκε.",
    "blog.back_all": "Πίσω σε όλες τις συνταγές →",
    "blog.default_tag": "Συνταγή",
    "country.CY": "Κύπρος",
    "country.GR": "Ελλάδα",
    "country.INTL": "Διεθνώς",
    "account.orders.tracking": "Παρακολούθηση ACS",
    "account.orders.track_link": "Παρακολούθηση αποστολής",
    "account.orders.eta": "Εκτ. παράδοση",
    "account.orders.eta_range": "{from_date} – {to_date}",
    "account.orders.eta_single": "έως {date}",
    "account.orders.delivered": "Παραδόθηκε",
    "account.orders.in_transit": "Σε μεταφορά",
    "newsletter.dismiss": "Κλείσιμο",
  },
};

const I18nContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

function interpolate(str, vars) {
  if (!vars) return str;
  return String(str).replace(/\{(\w+)\}/g, (_, k) => (k in vars ? String(vars[k]) : `{${k}}`));
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("brunchi_lang") || "en"; } catch { return "en"; }
  });

  useEffect(() => {
    try { localStorage.setItem("brunchi_lang", lang); } catch {}
    try { document.documentElement.setAttribute("lang", lang); } catch {}
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "el" ? "el" : "en"), []);
  const t = useCallback((key, vars) => {
    const val = (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key;
    return interpolate(val, vars);
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useT = () => useContext(I18nContext);
